module.exports = __webpack_public_path__ + "img/A1C.95cb81e4.jpg";